import { render } from "./SpecNote.vue?vue&type=template&id=7bff5aec&scoped=true"
import script from "./SpecNote.vue?vue&type=script&lang=js"
export * from "./SpecNote.vue?vue&type=script&lang=js"

import "./SpecNote.vue?vue&type=style&index=0&id=7bff5aec&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-7bff5aec"

export default script